import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getQueryDetail } from "../api/queryApi";
import { showError } from "../utils/alert";
import { formatDateTime } from "../utils/dateFormat";

function statusLabel(status) {
  if (status === 1) return "Responded";
  if (status === 0) return "Pending";
  return String(status);
}

export default function QueryDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await getQueryDetail(id);
        setData(res.data);
      } catch (err) {
        showError("Failed to load query detail");
        navigate("/queries");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id, navigate]);

  return (
    <AdminLayout title="Query Detail">
      {loading && <p>Loading...</p>}
      {!loading && data && (
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="card-title mb-3">Query Details</h5>
            <dl className="row mb-0 small">
              <dt className="col-sm-3">ID</dt>
              <dd className="col-sm-9">{data.id}</dd>

              <dt className="col-sm-3">Subject / Title</dt>
              <dd className="col-sm-9">{data.subject}</dd>

              <dt className="col-sm-3">Email</dt>
              <dd className="col-sm-9">{data.email}</dd>

              <dt className="col-sm-3">User</dt>
              <dd className="col-sm-9">
                {data.user_first_name || data.user_last_name
                  ? `${data.user_first_name || ""} ${data.user_last_name || ""}`.trim()
                  : "-"}
              </dd>

              <dt className="col-sm-3">Message</dt>
              <dd className="col-sm-9">
                <div className="border rounded p-2 bg-light text-break">
                  {data.message || "-"}
                </div>
              </dd>

              <dt className="col-sm-3">IP Address</dt>
              <dd className="col-sm-9">{data.ip_address || "-"}</dd>

              <dt className="col-sm-3">Status</dt>
              <dd className="col-sm-9">{statusLabel(data.status)}</dd>

              <dt className="col-sm-3">Created At</dt>
              <dd className="col-sm-9">{formatDateTime(data.created_at)}</dd>
            </dl>
            <div className="mt-3">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => navigate("/queries")}
              >
                Back to List
              </button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
